import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {IVideo, IVideoCollection} from "../main/components/sidebar/sidebar.component";
import {Observable, of} from "rxjs";
import {NewProject, NewProjectTypeName} from "../interfaces/app.interfaces";
import {Model} from "./api.service";
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class VideoCollectionService {

  private readonly endpoint: string =  environment.backend.url;

  constructor(
      private http: HttpClient,
  ) { }


  deleteVideo(videoCollectionId: string, videoId: string) {
    return this.http.delete(`${this.endpoint}/video-collections/${videoCollectionId}/videos/${videoId}`)
  }

  getVideoCollectionById(id: string): Observable<IVideoCollection> {
    return this.http.get<IVideoCollection>(`${this.endpoint}/video-collections/${id}`);
  };

  getVideoContentById(videoId: string, collectionId: string): Observable<Blob> {
    return this.http.get(`${this.endpoint}/video-collections/${collectionId}/videos/${videoId}/content`, { responseType: 'blob' });
  };

  getVideoById(videoId: string, collectionId: string): Observable<IVideo> {
    return this.http.get<IVideo>(`${this.endpoint}/video-collections/${collectionId}/videos/${videoId}`);
  };

  submitVideoCreation(collectionId: string, prompt: string, model: Model):Observable<IVideo[]> {
    const data  = {
      model: model.name,
      prompt,
      aspectRatio: "16:9",
      duration: 8
    }
    return this.http.post<IVideo[]>(`${this.endpoint}/video-collections/${collectionId}/videos`,data)
  }

  deleteVideoCollection(collectionId: string): Observable<any> {
    return this.http.delete(`${this.endpoint}/video-collections/${collectionId}`)
  }

  createVideoCollection(model: Model): Observable<NewProject> {
    const payload = {
      model: model.name
    }
    return this.http.post<NewProject>(`${this.endpoint}/video-collections/`, payload).pipe(
        // TODO: remove this map, when models on backend will be in sync
        map(data => {
          return {...data, projectTypeName: NewProjectTypeName.VideoCollection}
        } )
    );

  }

  renameVideoCollection(id: string, title: string): Observable<NewProject> {
    const data = {
      title
    }
    return this.http.patch<NewProject>(`${this.endpoint}/video-collections/${id}`,data);
  }

}


export enum Rendition {
  Original,
  Thumbnail,
  Attachment,
  Web
}
